/* eslint-disable */
import PropTypes from 'prop-types';
import ServicesContextPropTypes from '../../Contexts/Services/Services.props';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const HereMapsPropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The services to be used by the given entry
   */
  services: ServicesContextPropTypes.services.isRequired,

  /**
   * The callback to call on location change
   */
  onLocationChange: PropTypes.func,

  /**
   * The default location
   */
  defaultLocation: PropTypes.object,

  /**
   * Is disabled
   */
  disabled: PropTypes.bool,
};

export default HereMapsPropTypes;
